var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseHeavy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 50",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "arrow_from_icon_font"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#312D2A",
    d: "M49.8,0.5H7.2c-2,0-3.7,1.7-3.7,3.7v41.6c0,2,1.7,3.7,3.7,3.7h42.6c2,0,3.7-1.7,3.7-3.7V4.2 C53.5,2.2,51.8,0.5,49.8,0.5z M41.9,35.5L39,38.4L28.5,27.8L18,38.4l-2.8-2.8L25.7,25L15.1,14.5l2.8-2.8l10.5,10.6L39,11.6 l2.8,2.8L31.3,25L41.9,35.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBF9F8",
    points: "39,11.6 28.5,22.2 18,11.6 15.1,14.5 25.7,25 15.1,35.5 18,38.4 28.5,27.8 39,38.4 41.9,35.5  31.3,25 41.9,14.5  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseHeavy);
export default __webpack_public_path__ + "static/media/close_heavy.80225e3e.svg";
export { ForwardRef as ReactComponent };